/* eslint-disable @typescript-eslint/no-explicit-any */

export default function Paper(): any {
  return {
    MuiPaper: {
      defaultProps: { elevation: 0 },

      styleOverrides: { root: { backgroundImage: "none", paddingLeft: 0, paddingRight: 0 } },
    },
  };
}
